import React, { useContext } from 'react';
import styled from 'styled-components';

import { UserContext } from 'constants/user-context';

import { TotemButton } from 'ui/Button';
import { analyticsEvents, analyticsPropertiesConstants, track } from 'tracking/segment';

import { TotemInput, TotemLabel } from 'styles';
import { Popup, PopupContent, CloseContainer, PopupTitle } from 'styles/pages/settings.styles';
import { RemoveIcon } from 'styles/components/card.styles';
import { CardSuggestionProps } from 'pages/Totem/TotemProducts/TotemProducts.types';
import { usePostToSlackMutation } from 'data/__generated__';

export const SuggestionPopup: React.FC<CardSuggestionProps> = ({ currentCategory, setIsSuggestionPopupOpen }) => {
    const [postMessageToSlack] = usePostToSlackMutation();
    const userContext = useContext(UserContext);
    const firstname = userContext?.user?.profile?.firstname;
    const lastname = userContext?.user?.profile?.lastname;

    function postSuggestionToSlack(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();
        const formValues = [...new FormData(e.target as HTMLFormElement).entries()].reduce<Record<string, string>>(
            (acc, [key, value]) => ({
                ...acc,
                [key]: value as string,
            }),
            {},
        );
        const { productName, productBrand } = formValues;
        if (productName || productBrand) {
            postMessageToSlack({
                variables: {
                    message: `• ${firstname} ${lastname} aimerait beaucoup qu'on ajoute ${productName}${
                        productBrand ? ` de la marque ${productBrand}` : ''
                    } à la catégorie ${currentCategory?.title}`,
                },
            });
        }
        track(analyticsEvents.CREATE_PRODUCT_SUGGESTION, {
            [analyticsPropertiesConstants.PRODUCTS.CATEGORY]: currentCategory?.title,
            [analyticsPropertiesConstants.PRODUCTS.CATEGORY_ID]: currentCategory?._id,
            [analyticsPropertiesConstants.PRODUCTS.NAME]: productName,
            [analyticsPropertiesConstants.PRODUCTS.BRAND]: productBrand,
        });
        setIsSuggestionPopupOpen(false);
    }

    return (
        <Popup $alignItems="center" $justifyContent="center">
            <PopupContent $paddings={[2, 2, 4, 2]} $spaceBetween $width="455px" onClick={(e) => e.stopPropagation()}>
                <PopupTitle>Suggestion de produit</PopupTitle>
                <ProductSuggestionForm onSubmit={postSuggestionToSlack}>
                    <TotemLabel>
                        Nom du produit
                        <TotemInput placeholder="Entrez le nom du produit désiré" name="productName" autoFocus />
                    </TotemLabel>
                    <TotemLabel>
                        Marque du produit
                        <TotemInput placeholder="Entrez la marque du produit désiré" name="productBrand" />
                    </TotemLabel>
                    <TotemButton type="submit" style={{ minWidth: 100 }}>
                        Suggérer
                    </TotemButton>
                </ProductSuggestionForm>
                <CloseContainer>
                    <RemoveIcon size="25px" onClick={() => setIsSuggestionPopupOpen(false)} />
                </CloseContainer>
            </PopupContent>
        </Popup>
    );
};

const ProductSuggestionForm = styled.form`
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 0 20px;
    width: 100%;
`;
